import { useState, useEffect } from "react";
import cn from "classnames";
import {
  initClient as initGoogleClient,
  signIn as signInToGoogle,
  signOut as signOutFromGoogle,
  getSignature,
  setSignature,
} from "../../services/google";
import "./App.scss";
import Input from "../Input/Input";
import Toggle from "../Toggle/Toggle";
import { ALLOWED_DOMAINS, ICONS_URL } from "../../config";

const arrowRight = `${ICONS_URL}/arrowRight.png`;
const facebook = `${ICONS_URL}/facebook3.png`;
const linkedin = `${ICONS_URL}/linkedin3.png`;
const instagram = `${ICONS_URL}/instagram2.png`;
const youtube = `${ICONS_URL}/youtube2.png`;
const tiktok = `${ICONS_URL}/tiktok.png`;
const google = `${ICONS_URL}/google2.png`;
const logoSteer = `${ICONS_URL}/logoSteer.png`;
const logoAutoOps = `${ICONS_URL}/logoAutoOps.png`;

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSignature, setCurrentSignature] = useState("");
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [position, setPosition] = useState("");
  const [isCurrentSignatureShown, setIsCurrentSignatureShown] = useState(true);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);
  const [signatureType, setSignatureType] = useState("steer");
  const isSteerType = signatureType === "steer";

  const config = isSteerType
    ? {
        btnLink: "https://hubs.ly/Q035DFsp0",
        btnLabel: "get a demo",
        linkGoogle: "https://g.page/r/Cc6_bEZhCTibEBM/review",
        linkFacebook: "https://www.facebook.com/steercrm",
        linkInstagram: "https://www.instagram.com/steercrm",
        linkLinkedIn: "https://www.linkedin.com/company/steercrm/",
        linkYouTube: "https://www.youtube.com/@steercrm",
        linkTikTok: "http://tiktok.com/@steercrm",
        linkLogo: "https://steercrm.com/",
        helperTextEmail: "Use your Steer email",
        logo: logoSteer,
        logoWidth: "89px",
        company: ", Steer & AutoOps",
        logoPlaceholderLeft:
          "min-width: 12px; width: 30px; max-width: 3vw; color: transparent;",
        logoPadding: "38px 0px 34px",
      }
    : {
        btnLink: "https://hubs.ly/Q035Dtz40",
        btnLabel: "meet with me",
        linkGoogle: "https://g.page/r/CbbCLzoHjGfyEBM/review",
        linkFacebook: "https://www.facebook.com/getautoops/",
        linkInstagram: "https://www.instagram.com/getautoops/",
        linkLinkedIn: "https://www.linkedin.com/company/get-autoops/",
        linkTikTok: "https://www.tiktok.com/@autoops",
        linkLogo: "https://www.autoops.com/",
        helperTextEmail: "Use your AutoOps email",
        logo: logoAutoOps,
        logoWidth: "115px",
        company: ", AutoOps",
        logoPlaceholderLeft: "width: 0px; color: transparent;",
        logoPadding: "35px 0px 31px",
      };

  const [btnLink, setBtnLink] = useState(config.btnLink);

  const signatureResult = `
  <table style="display: flex; font-family: Helvetica; color: #474E5D; max-width: 550px;">
    <tr>
      <td>
        <div style="display: flex">
          <div style="${config.logoPlaceholderLeft}">.</div>
          <div style="display: flex; padding: ${config.logoPadding};">
            <a href="${config.linkLogo}" target="_blank">
              <img src="${config.logo}" alt="" style="width: ${
    config.logoWidth
  };"/>
            </a>
          </div>
          <div style="min-width: 12px; width: 30px; max-width: 3vw; color: transparent;">.</div>
          <div style="width: 1px; min-height: 150px; background: #D3D3D3; color: transparent;">.</div>
          <div style="min-width: 12px; width: 30px; max-width: 3vw; color: transparent;">.</div>
        </div>
      </td>
      <td>
        <div style="padding: 13px 0;">  
          <div style="color: #191919; margin-bottom: 7px; font-size: 16px; font-weight: 700; line-height: normal;">
            ${fullName}
          </div>
          <div style="color: #191919; margin-bottom: 6px; font-size: 14px; font-weight: 400; line-height: normal;">
            ${position}${config.company}
          </div>
          <div style="margin-bottom: 6px; color: #191919; font-weight: 400; font-size: 14px; line-height: normal;">
            <a href="" target="_blank" style="text-decoration: none; color: #191919;">
              <span style="text-decoration: none; color: #191919;">${phone}</span>
            </a>
          </div>
          <div style="color: #191919; font-weight: 400; font-size: 14px; line-height: normal;">
            <a href="mailto:${email}" target="_blank" style="text-decoration: none; color: #191919;">
              <span style="text-decoration: none; color: #191919;">${email}</span>
            </a>
          </div>
          <div style="display: inline-block; margin-right: 15px; margin-top: 13px">
            <a href="${btnLink}" target="_blank" style="text-decoration: none;">
              <div style="background-color: #D7282F; color: #fff; font-size: 12px; line-height: 25px; font-weight: bold; text-transform: uppercase; vertical-align: middle; display: inline-block; padding: 0px 11px;">
                <img src="${arrowRight}" alt="" style="width: 8px; height: 8px; margin-right: 4px;"/>${
    config.btnLabel
  }
              </div>
            </a>
          </div>
          <div style="display: inline-block; margin-top: 13px; line-height: 14px">
            <div style="display: inline-block; width: 1px; color: transparent;">.</div>
            <div style="display: inline-block; margin-right: 15px; vertical-align: middle; height: 14px;">
              <a href="${
                config.linkGoogle
              }" target="_blank" style="display: block; height: 14px; text-decoration: none; color: #D3D3D3;">
                <img src="${google}" alt="" style="width: 14px; height: 14px;"/>
              </a>
            </div>
            <div style="display: inline-block; margin-right: 15px; vertical-align: middle; height: 14px;">
              <a href="${
                config.linkFacebook
              }" target="_blank" style="display: block; height: 14px; text-decoration: none; color: #D3D3D3;">
                <img src="${facebook}" alt="" style="width: 14px; height: 14px;"/>
              </a>
            </div>
            <div style="display: inline-block; margin-right: 15px; vertical-align: middle; height: 14px;">
              <a href="${
                config.linkInstagram
              }" target="_blank" style="display: block; height: 14px; text-decoration: none; color: #D3D3D3;">
                <img src="${instagram}" alt="" style="width: 14px; height: 14px;"/>
              </a>
            </div>
            <div style="display: inline-block; margin-right: 15px; vertical-align: middle; height: 14px;">
              <a href="${
                config.linkLinkedIn
              }" target="_blank" style="display: block; height: 14px; text-decoration: none; color: #D3D3D3;">
                <img src="${linkedin}" alt="" style="width: 14px; height: 14px;"/>
              </a>
            </div>
            ${
              isSteerType
                ? `<div style="display: inline-block; margin-right: 15px; vertical-align: middle; height: 14px;">
                      <a href="${config.linkYouTube}" target="_blank" style="display: block; height: 14px; text-decoration: none; color: #D3D3D3;">
                        <img src="${youtube}" alt="" style="width: 14px; height: 14px;"/>
                      </a>
                    </div>`
                : ""
            }
            <div style="display: inline-block; vertical-align: middle; height: 14px;">
              <a href="${
                config.linkTikTok
              }" target="_blank" style="display: block; height: 14px; text-decoration: none; color: #D3D3D3;">
                <img src="${tiktok}" alt="" style="width: 14px; height: 14px;"/>
              </a>
            </div>
            <div style="display: inline-block; width: 1px; color: transparent;">.</div>
          </div>
        </>
      </td>
    </tr>
  </table>
  `;

  useEffect(() => {
    initGoogleClient(() => {
      setIsLoggedIn(true);
      setIsLoading(true);
    });
  }, []);

  useEffect(() => {
    async function fetchSignature() {
      if (isLoggedIn) {
        const { email, signature } = await getSignature();
        setEmail(email);
        setCurrentSignature(signature);

        const match = email.match(/(?<=@).*\.\w{2,3}$/);
        const isAllowed = match && ALLOWED_DOMAINS.includes(match[0]);

        if (!isAllowed) setIsLoggedIn(false);
        setIsLoading(false);
      }
    }
    fetchSignature();
  }, [isLoggedIn]);

  const handleSignOut = () => {
    signOutFromGoogle();
    setIsLoggedIn(false);
  };

  const updateSignature = async () => {
    setIsSignatureLoading(true);
    const result = await setSignature(signatureResult);
    if (result) {
      setCurrentSignature(result);
      setIsCurrentSignatureShown(true);
      setIsSignatureLoading(false);
    }
  };

  function handlePhoneChange(value) {
    const maskedValue = value
      .replace(/^(\d)/, "($1")
      .replace(/^(\(\d{3})(\d)/, "$1) $2")
      .replace(/^(\(\d{3}\) \d{3})(?=\d)/, "$1-")
      .replace(/^(\(\d{3}\) \d{3}-\d{4})(?=\S)/, "$1 ");

    setPhone(maskedValue);
  }

  useEffect(() => {
    setBtnLink(config.btnLink);
  }, [isSteerType]);

  if (isLoading) return null;

  return (
    <div className="app">
      {isLoggedIn ? (
        <>
          <div className="app-header">
            <div className="header-text">Select a signature type</div>
            <button className="main-button" onClick={handleSignOut}>
              Sign Out
            </button>
          </div>
          <Toggle
            onSelect={(option) => setSignatureType(option)}
            selected={signatureType}
          />
          <div className="header-text">Email signature settings</div>
          <div className="form-container">
            <div className="input-row">
              <Input
                value={fullName}
                name="fullName"
                id="fullName"
                label="Full name"
                onChange={(e) => {
                  setIsCurrentSignatureShown(false);
                  setFullName(e.target.value);
                }}
              />
              <Input
                name="position"
                id="position"
                label="Position"
                value={position}
                onChange={(e) => {
                  setIsCurrentSignatureShown(false);
                  setPosition(e.target.value);
                }}
              />
            </div>
            <div className="input-row">
              <Input
                value={email}
                onChange={(e) => {
                  setIsCurrentSignatureShown(false);
                  setEmail(e.target.value);
                }}
                name="email"
                id="email"
                label="Email"
                helperText={config.helperTextEmail}
              />
              <Input
                name="phone"
                id="phone"
                label="Phone"
                value={phone}
                onChange={(e) => {
                  setIsCurrentSignatureShown(false);
                  handlePhoneChange(e.target.value);
                }}
              />
            </div>
            <Input
              name="link"
              id="link"
              value={btnLink}
              onChange={(e) => {
                setIsCurrentSignatureShown(false);
                setBtnLink(e.target.value);
              }}
              label="Call-to-Action"
              placeholder="Paste link here"
              helperText="Add your Hubspot scheduling link or other relevant featured link here"
            />
            <Input
              label="Generated code"
              value={signatureResult}
              name="resultContainer"
              multiline
            ></Input>
            <div className="form-button">
              <button
                onClick={() => {
                  updateSignature();
                }}
                className="main-button"
              >
                {isSignatureLoading ? (
                  <div className="loader"></div>
                ) : (
                  "Set Signature"
                )}
              </button>
            </div>
          </div>
          <div className="preview-container">
            <div className="preview-header-menu">
              <div
                className={cn("preview-menu-item", {
                  "active-item": isCurrentSignatureShown,
                })}
                onClick={() => {
                  setIsCurrentSignatureShown(true);
                }}
              >
                Current Signature
              </div>
              <div
                className={cn("preview-menu-item", {
                  "active-item": !isCurrentSignatureShown,
                })}
                onClick={() => {
                  setIsCurrentSignatureShown(false);
                }}
              >
                New signature preview
              </div>
            </div>
            {!isCurrentSignatureShown && (
              <div dangerouslySetInnerHTML={{ __html: signatureResult }}></div>
            )}
            {isCurrentSignatureShown && (
              <div dangerouslySetInnerHTML={{ __html: currentSignature }}></div>
            )}
          </div>
        </>
      ) : (
        <div className="signIn-button">
          <button className="main-button" onClick={signInToGoogle}>
            Sign In
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
